import React, { useState, useEffect, useMemo } from "react";
import services from "@/services";
import style from "./style.module.scss";
import { base } from "@/services/api/_base";
const { apis } = services;

export default function AutoPavilion(props: any) {
  const { data } = props || {};
  const [currentGood, setCurrentGood]: any = useState({}); // 当前tab车系数据
  const [framUrl, setFramUrl]: any = useState(""); // 360度链接
  const [carImgList, setCarImgList]: any = useState([]); // 车系透明图列表

  // 获取车系其他信息
  const getSeriesInfo = async (params: any) => {
    const { data } = params;
    if (!data || data.length < 1) {
      return false;
    }
    const serieslist = data.map((item: any) => item.data.cms_series_ids);
    let res = await apis.getSeriesPic({
      _appid: "mall",
      serieslist: serieslist.join(","),
    });
    if (res?.returncode === 0 && res?.result?.serieslist?.length > 0) {
      setCarImgList(res.result.serieslist);
    } else {
      return data;
    }
  };

  const goodsList = useMemo(() => {
    if (!(data?.goodsObj?.list?.length > 0)) {
      return [];
    }
    const seriesIdList: any = {};
    // 车系ID去重处理
    const res = data.goodsObj.list.filter((item: any) => {
      let seriesId = item?.data?.cms_series_ids;
      if (seriesId && !seriesIdList[seriesId]) {
        // item.data.cms_series_ids = 66;
        seriesIdList[seriesId] = 1;
        return true;
      }
      return false;
    });
    getSeriesInfo({ data: res });
    if (res?.length > 0) {
      setCurrentGood(Object.assign({ ...res[0] }, { index: 0 }));
    }
    return res;
  }, [data?.goodsObj?.list]);

  // 滚动
  const toScroll = (ele: any, target: any) => {
    if (Math.abs(target) <= 10) {
      ele.scrollLeft = ele.scrollLeft + target;
    } else {
      if (target < 0) {
        ele.scrollLeft = ele.scrollLeft - 10;
      } else {
        ele.scrollLeft = ele.scrollLeft + 10;
      }
      setTimeout(() => {
        let newTarget;
        if (target < 0) {
          newTarget = target + 10;
        } else {
          newTarget = target - 10;
        }
        toScroll(ele, newTarget);
      }, 16);
    }
  };

  const findTarget = (e: any) => {
    let target = e.target;
    let findTimes = 0;
    console.log(
      "target",
      target,
      target.className,
      target.className.split(" ")
    );
    while (
      target &&
      !target.className.split(" ").includes("good-item") &&
      findTimes < 5
    ) {
      target = target.parentNode;
    }
    if (target && target.className.split(" ").includes("good-item")) {
      return target;
    } else {
      return null;
    }
  };

  const changeGood = (e: any, goodItem: any, index: any) => {
    setCurrentGood(Object.assign(goodItem, { index }));
    const parent: any = document.getElementById("select-series-inner");
    const targetNode = findTarget(e);
    // 最后加20是select-series-wrap元素的paddingLeft
    if (targetNode) {
      const targetOffsetLeft =
        targetNode.offsetLeft -
        window.innerWidth / 2 +
        targetNode.offsetWidth / 2 +
        20;
      toScroll(parent, targetOffsetLeft - parent.scrollLeft);
    }
  };

  const handleClickSwitch = (type: any) => {
    try {
      let newIndex;
      if (type === "left") {
        newIndex = currentGood?.index - 1;
      } else {
        newIndex = currentGood?.index + 1;
      }
      if (newIndex >= 0 && newIndex < goodsList?.length) {
        let targetDom = document.getElementsByClassName("good-item")[
          newIndex
        ] as HTMLElement | null;
        targetDom?.click();
      }
    } catch (error) {
      console.log("切换报错", error);
    }
  };

  const getcarvrinfobyseriesid = async () => {
    const seriesid = currentGood.data?.cms_series_ids || "0";
    const res = await apis.getcarvrinfobyseriesidApi({ seriesid });
    if (res?.ReturnCode === 0 && res.Result?.ExtInfo?.length > 0) {
      setFramUrl(() => res.Result?.ExtInfo[0].iframe_url);
    } else {
      setFramUrl("");
    }
  };

  const goDetailPage = () => {
    window.location.href = base.isProduct
      ? `https://mcar.mall.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${currentGood?.data?.biz_id}`
      : `http://leads2.terra.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${currentGood?.data?.biz_id}`;
  };

  useEffect(() => {
    getcarvrinfobyseriesid();
  }, [currentGood?.data?.cms_series_ids]);

  return (
    <div className={style["auto-pavilion-inner"]}>
      <div className={style["select-series-wrap"]}>
        <div className={style["select-series-inner"]} id="select-series-inner">
          {goodsList?.map((goodItem: any, index: any) => {
            return (
              <div
                className={
                  style["good-item"] +
                  ` ${
                    goodItem.data?.cms_series_ids ===
                    currentGood?.data?.cms_series_ids
                      ? style["good-item-active"]
                      : ""
                  }` +
                  " good-item"
                }
                onClick={(e) => {
                  changeGood(e, goodItem, index);
                }}
                key={goodItem.data?.cms_series_ids}
              >
                {goodItem.data?.cms_series_names}
              </div>
            );
          })}
        </div>
        <div
          className={style["carousel-left-wrap"]}
          onClick={() => {
            handleClickSwitch("left");
          }}
        >
          <i className={style["carousel-left"]}></i>
        </div>
        <div
          className={style["carousel-right-wrap"]}
          onClick={() => {
            handleClickSwitch("right");
          }}
        >
          <i className={style["carousel-right"]}></i>
        </div>
      </div>

      <div className={style["pic-wrap"]}>
        {/* 3Diframe */}
        {framUrl ? (
          <iframe
            src={`${framUrl}?bg=99&noswitch=1&spin=1&btnoffsety=20&caroffsety=45`}
            width="100%"
            height="100%"
            frameBorder={0}
          />
        ) : (
          <img src={carImgList[currentGood?.index]?.pnglogo} />
        )}
      </div>

      <div className={style["series-info-wrap"]}>
        <div className={style["series-info-title"]}>
          {currentGood?.data?.title}
        </div>
        <div className={style["series-info-worth"]}>
          {currentGood?.data?.worth > 0 ? (
            <div>
              <span className={style["series-worth"]}>
                {currentGood?.data?.worth}
              </span>
              元权益
            </div>
          ) : (
            "火热抢购"
          )}
        </div>
        <div
          className={style["receive-button"]}
          onClick={() => {
            goDetailPage();
          }}
        ></div>
      </div>
    </div>
  );
}
